import styled from "styled-components";

export const StyledButton = styled.div`
    margin-left: 4px;
`;
